import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import { accessRole } from "../../../../helpers/access_role"
import Shimmer from 'react-shimmer-effect';

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
if (accessRole('approve')) {
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
}


var reformatOptionPosition = function (regions) {
    return regions.map(function (region) {
        var newObj = {};
        newObj["label"] = region.position_name;
        newObj["value"] = region.position_uuid;

        return newObj;
    });
};

var reformatOptionEchelon = function (regions) {
    return regions.map(function (region) {
        var newObj = {};
        newObj["label"] = region.echelon_name;
        newObj["value"] = region.echelon_uuid;

        return newObj;
    });
};

var reformatOptionPositonStatus = function (regions) {
    return regions.map(function (region) {
        var newObj = {};
        newObj["label"] = region.position_status_name;
        newObj["value"] = region.position_status_uuid;

        return newObj;
    });
};

var reformatOptionWorkUnit = function (regions) {
    return regions.map(function (region) {
        var newObj = {};
        newObj["label"] = region.work_unit_name_tabs;
        newObj["value"] = region.work_unit_uuid;
        return newObj;
    });
};

var reformatOptionSignatoryOfficial = function (regions) {
    return regions.map(function (region) {
        var newObj = {};
        newObj["label"] = region.signatories_official_name;
        newObj["value"] = region.signatories_official_name;
        return newObj;
    });
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
            positionItems: [],
            PositionSelected: "",
            echelonItems: [],
            echelonSelected: "",
            positionStatusItems: [],
            PositionStatusSelected: "",
            workUnitFormItems: [],
            workUnitFormSelected: "",
            workUnitToItems: [],
            workUnitToSelected: "",
            signantoryItems: [],
            signatorySelected: "",
        }
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'document')
        await this.updateBloc.fetchUpdate(dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                employee_uuid: peg_uuid,
                ...values
            },
            confirm: true
        })
    }

    onChangePosition = (PositionSelected) => {
        this.setState({
            PositionSelected: PositionSelected.value
        });
    }

    onChangeEchelon = (echelonSelected) => {
        this.setState({
            echelonSelected: echelonSelected.value
        });
    }

    onChangePositionStatus = (PositionStatusSelected) => {
        this.setState({
            PositionStatusSelected: PositionStatusSelected.value
        });
    }

    onChangeWorkUnitForm = (workUnitFormSelected) => {
        this.setState({
            workUnitFormSelected: workUnitFormSelected.value
        });
    }

    onChangeWorkUnitTo = (workUnitToSelected) => {
        this.setState({
            workUnitToSelected: workUnitToSelected.value
        });
    }


    onChangeSignatory = (signatorySelected) => {
        this.setState({
            signatorySelected: signatorySelected.value
        });
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            positionItems: reformatOptionPosition(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.echelonChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            echelonItems: reformatOptionEchelon(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.positionStatusChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            positionStatusItems: reformatOptionPositonStatus(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        // console.log(response)

                        this.setState({
                            workUnitFormItems: reformatOptionWorkUnit(response.result),
                            workUnitToItems: reformatOptionWorkUnit(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.signatoryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        console.log(response)

                        this.setState({
                            signantoryItems: reformatOptionSignatoryOfficial(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        // load to form
                        this.setState({
                            dataForm: {
                                uuid: response.position_history_uuid,
                                employee_uuid: response.position_history_employee_uuid,
                                no_sk: response.position_history_decree_number,
                                kode_eselon: response.echelon_code,
                                tanggal_sk: response.position_history_decree_date,
                                position_uuid: response.position_history_position_uuid,
                                tmt_jabatan: response.position_history_tmt_position_date,
                                echelon_uuid: response.position_history_echelon_uuid,
                                tmt_eselon: response.position_history_tmt_echelon_date,
                                signatories_official: response.position_history_signatories_official,
                                no_pelantikan: response.position_history_inauguration_number,
                                tanggal_pelantikan: response.position_history_inauguration_date,
                                tunjangan: response.allowance,
                                bln_dibayar: response.position_history_allowance_pay_month,
                                work_unit_form_id: response.work_unit_form_id,
                                work_unit_to_id: response.work_unit_to_id,
                                position_status_uuid: response.position_history_position_status_uuid
                            },
                            PositionSelected: response.position_history_position_uuid,
                            echelonSelected: response.position_history_echelon_uuid,
                            PositionStatusSelected: response.position_history_position_status_uuid,
                            workUnitFormSelected: response.position_history_work_unit_uuid_from,
                            workUnitToSelected: response.position_history_work_unit_uuid_to,
                            signatorySelected: response.position_history_signatories_official,
                        })



                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        const search = window.location.search
        const queryParams = new URLSearchParams(search)
        this.updateBloc.fetchDetail({ uuid: queryParams.get('uuid') })

        this.updateBloc.fetchPosition()
        this.updateBloc.fetchEchelon()
        this.updateBloc.fetchPositionStatus()
        this.updateBloc.fetchWorkUnit()
        this.updateBloc.fetchSignatory()

    }



    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayatjabatan" />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Update Riwayat Jabatan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />


                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="uuid"
                                            value={this.state.dataForm?.uuid}
                                        />
                                        <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.state.dataForm?.employee_uuid}
                                        />

                                        <Row className="mb-3">
                                            <label htmlFor="no_sk" className="col-md-3 col-form-label">
                                                No SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm ? (
                                                    <AvField
                                                        name="no_sk"
                                                        placeholder="Nomor SK..."
                                                        type="text"
                                                        errorMessage="Masukkan Nomor SK"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="no_sk"
                                                        value={this.state.dataForm?.no_sk}
                                                    />
                                                ) : (
                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label htmlFor="tanggal_sk" className="col-md-3 col-form-label">
                                                Tanggal SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm ? (
                                                    <AvField
                                                        name="tanggal_sk"
                                                        placeholder="Tanggal SK..."
                                                        type="date"
                                                        errorMessage="Masukkan Tanggal SK"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="tanggal_sk"
                                                        value={this.state.dataForm?.tanggal_sk}
                                                    />
                                                ) : (
                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label htmlFor="position_id" className="col-md-3 col-form-label">
                                                Nama Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm ? (
                                                    <>
                                                        <Select
                                                            value={this.state.positionItems.filter(option =>
                                                                option.value === this.state.PositionSelected)}
                                                            onChange={this.onChangePosition}
                                                            required="required"
                                                            options={this.state.positionItems}
                                                            classNamePrefix=""
                                                        />
                                                        <AvField
                                                            name="position_id"
                                                            placeholder="Nama Jabatan..."
                                                            type="hidden"
                                                            errorMessage="Masukkan Nama Jabatan"
                                                            className="form-control"
                                                            validate={{ required: { value: true } }}
                                                            id="position_id"
                                                            value={this.state.PositionSelected}
                                                        />
                                                    </>
                                                ) : (
                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label htmlFor="tmt_jabatan" className="col-md-3 col-form-label">
                                                TMT Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                {this.state.dataForm ? (
                                                    <AvField
                                                        name="tmt_jabatan"
                                                        placeholder=" TMT Jabatan..."
                                                        type="date"
                                                        errorMessage="Masukkan  TMT Jabatan"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="tmt_jabatan"
                                                        value={this.state.dataForm?.tmt_jabatan}
                                                    />
                                                ) : (
                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                )}
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Eselon <span className="text-danger">*</span>
                                            </label>

                                            <Col md="5">
                                                <Select
                                                    value={this.state.echelonItems.filter(option =>
                                                        option.value === this.state.echelonSelected)}
                                                    onChange={
                                                        this.onChangeEchelon
                                                    }
                                                    required="required"
                                                    options={this.state.echelonItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="echelon_id"
                                                    placeholder="Nama Eselon..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Nama Eselon"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="echelon_id"
                                                    value={this.state.echelonSelected}
                                                />
                                            </Col>

                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Kode Eselon <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="kode_eselon"
                                                    placeholder="Kode Eselon..."
                                                    type="text"
                                                    errorMessage="Masukkan Kode Eselon"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="kode_eselon"
                                                    value={this.state.dataForm?.kode_eselon}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                TMT Eselon <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tmt_eselon"
                                                    placeholder=" TMT Eselon..."
                                                    type="date"
                                                    errorMessage="Masukkan  TMT Eselon"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tmt_eselon"
                                                    value={this.state.dataForm?.tmt_eselon}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Pejabat Penetap <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.signantoryItems.filter(option =>
                                                        option.value === this.state.signatorySelected)}
                                                    onChange={
                                                        this.onChangeSignatory
                                                    }
                                                    required="required"
                                                    options={this.state.signantoryItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="signatory_name"
                                                    placeholder="Nama Jabatan..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Penanda Tangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="signatory_name"
                                                    value={this.state.signatorySelected}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                No Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="no_pelantikan"
                                                    placeholder="Nomor Pelantikan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Pelantikan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="no_pelantikan"
                                                    value={this.state.dataForm?.no_pelantikan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_pelantikan"
                                                    placeholder="Tanggal Pelantikan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Pelantikan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tanggal_pelantikan"
                                                    value={this.state.dataForm?.tanggal_pelantikan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Tunjangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tunjangan"
                                                    placeholder="Tunjangan..."
                                                    type="number"
                                                    min={0}
                                                    errorMessage="Masukkan Tunjangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tunjangan"
                                                    value={this.state.dataForm?.tunjangan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Bulan Dibayar <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="bln_dibayar"
                                                    placeholder=" TMT Eselon..."
                                                    type="date"
                                                    errorMessage="Masukkan Bulan Dibayar"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="bln_dibayar"
                                                    value={this.state.dataForm?.bln_dibayar}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Unit Kerja Asal <span className="text-danger">*</span>
                                            </label>

                                            <Col md="5">
                                                <Select
                                                    value={this.state.workUnitFormItems.filter(option =>
                                                        option.value === this.state.workUnitFormSelected)}
                                                    onChange={
                                                        this.onChangeWorkUnitForm
                                                    }
                                                    required="required"
                                                    options={this.state.workUnitFormItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="work_unit_form_id"
                                                    placeholder="Nama Unit Kerja..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Unit Kerja"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_unit_form_id"
                                                    value={this.state.workUnitFormSelected}
                                                />
                                            </Col>

                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Unit Kerja Tujuan <span className="text-danger">*</span>
                                            </label>

                                            <Col md="5">
                                                <Select
                                                    value={this.state.workUnitToItems.filter(option =>
                                                        option.value === this.state.workUnitToSelected)}
                                                    onChange={
                                                        this.onChangeWorkUnitTo
                                                    }
                                                    required="required"
                                                    options={this.state.workUnitToItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="work_unit_to_id"
                                                    placeholder="Nama Unit Kerja..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Unit Kerja"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_unit_to_id"
                                                    value={this.state.workUnitToSelected}
                                                />
                                            </Col>

                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Status Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">

                                                <Select
                                                    value={this.state.positionStatusItems.filter(option =>
                                                        option.value === this.state.PositionStatusSelected)}
                                                    onChange={
                                                        this.onChangePositionStatus
                                                    }
                                                    required="required"
                                                    options={this.state.positionStatusItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="position_status_id"
                                                    placeholder="Nama Status Jabatan..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Status Jabatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="position_status_id"
                                                    value={this.state.PositionStatusSelected}
                                                />

                                            </Col>

                                        </Row> */}

                                        <Row className="mb-3 mt-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                File SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="6">
                                                {this.state.dataForm ? (
                                                    <FileInput
                                                        name="document"
                                                        placeholder="Upload File SK"
                                                        className="form-control"
                                                    />
                                                    ) : (
                                                        <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Unit Kerja Asal <span className="text-danger">*</span>
                                            </label>

                                            <Col md="5">
                                            {this.state.dataForm ? (
                                                <>
                                                    <Select
                                                        value={this.state.workUnitFormItems.filter(option =>
                                                            option.value === this.state.workUnitFormSelected)}
                                                        onChange={
                                                            this.onChangeWorkUnitForm
                                                        }
                                                        required="required"
                                                        options={this.state.workUnitFormItems}
                                                        isLoading={!this.state.workUnitFormItems?.length}
                                                        classNamePrefix=""
                                                    />

                                                    <AvField
                                                        name="work_unit_form_id"
                                                        placeholder="Nama Unit Kerja..."
                                                        type="hidden"
                                                        errorMessage="Masukkan Unit Kerja"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="work_unit_form_id"
                                                        value={this.state.workUnitFormSelected}
                                                    />
                                                </>
                                                ) : (
                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            )}
                                            </Col>

                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Unit Kerja Tujuan <span className="text-danger">*</span>
                                            </label>

                                            <Col md="5">
                                            {this.state.dataForm ? (
                                                <>
                                                    <Select
                                                        value={this.state.workUnitToItems.filter(option =>
                                                            option.value === this.state.workUnitToSelected)}
                                                        onChange={
                                                            this.onChangeWorkUnitTo
                                                        }
                                                        required="required"
                                                        options={this.state.workUnitToItems}
                                                        isLoading={!this.state.workUnitToItems?.length}
                                                        classNamePrefix=""
                                                    />

                                                    <AvField
                                                        name="work_unit_to_id"
                                                        placeholder="Nama Unit Kerja..."
                                                        type="hidden"
                                                        errorMessage="Masukkan Unit Kerja"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="work_unit_to_id"
                                                        value={this.state.workUnitToSelected}
                                                    />
                                                </>
                                                ) : (
                                                    <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            )}
                                            </Col>

                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayatjabatan">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayatjabatan' />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView